import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  CircularProgress,
  Divider,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";
import { useSelector } from "react-redux";
import axios from "axios";
import { BASE_URL } from "../../components/config/config";

const ClientServiceCategory = () => {
  const clientState = useSelector((state) => state.clientReducer);
  const clientId = clientState.clientDetails?._id;

  const [clientData, setClientData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchClientData = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}client/get-client-report/${clientId}`
        );
        if (response.data?.success && response.data?.data) {
          setClientData(response.data.data);
        } else {
          setError("No data received from server");
        }
      } catch (error) {
        setError(error.message || "Failed to fetch client data");
      } finally {
        setLoading(false);
      }
    };

    if (clientId) {
      fetchClientData();
    } else {
      setError("No client ID found");
      setLoading(false);
    }
  }, [clientId]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">Error: {error}</Typography>
      </Box>
    );
  }

  if (!clientData) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>No client data available</Typography>
      </Box>
    );
  }

  const clientDetails = clientData.client_details || {};
  const categoryDetails = clientDetails.serviceAreas?.category_details || [];

  return (
    <Box sx={{ p: 3 }}>
      {/* Client Info */}
      <Box sx={{ mb: 4 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <Avatar sx={{ width: 80, height: 80 }}>
              {clientDetails.client_name?.charAt(0) || "C"}
            </Avatar>
          </Grid>
          <Grid item xs>
            <Typography variant="h4">
              {clientDetails.client_name || "No Name"}
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              ID: {clientDetails.client_id || "N/A"}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* Service Categories */}
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Service Categories
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                <TableCell sx={{ fontWeight: "bold" }}>Category</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Price (₹)</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>
                  Payment Method
                </TableCell>
                {/* <TableCell sx={{ fontWeight: "bold" }}>
                  Ticket Pic Prize (₹)
                </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {categoryDetails.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No service categories added yet
                  </TableCell>
                </TableRow>
              ) : (
                categoryDetails.map((category) => {
                  const paymentWay = category.payment_way || {};
                  const selectedValue = paymentWay.isPayViaCustomer
                    ? "customer"
                    : paymentWay.isPayViaClient
                    ? "client"
                    : "";

                  return (
                    <TableRow key={category.category_id}>
                      <TableCell>
                        {category.label || ""} {category.label2 || ""}
                      </TableCell>
                      <TableCell>
                        ₹{category.category_service_prize || 0}
                      </TableCell>
                      <TableCell>
                        <FormControl>
                          <RadioGroup row value={selectedValue}>
                            <FormControlLabel
                              value="customer"
                              control={<Radio disabled />}
                              label="Customer"
                            />
                            <FormControlLabel
                              value="client"
                              control={<Radio disabled />}
                              label="Client"
                            />
                          </RadioGroup>
                        </FormControl>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default ClientServiceCategory;
